import nextplay700 from "../assets/nextplay-ss-700.webp";
import nextplay1400 from "../assets/nextplay-ss-1400.webp";
import ambe700 from "../assets/ambe-ss-700.webp";
import ambe1400 from "../assets/ambe-ss-1400.webp";
import curzonrelo700 from "../assets/curzonrelo-ss-700.webp";
import curzonrelo1400 from "../assets/curzonrelo-ss-1400.webp";
import persyst700 from "../assets/persyst-ss-700.webp";
import persyst1400 from "../assets/persyst-ss-1400.webp";
import chinesepodSite700 from "../assets/chinesepod-ss-700.webp";
import chinesepodSite1400 from "../assets/chinesepod-ss-1400.webp";
import chinesepod700 from "../assets/chinesepod-app-700.webp";
import chinesepod1400 from "../assets/chinesepod-app-1400.webp";
import djohwoww700 from "../assets/djohwoww-ss-700.webp";
import djohwoww1400 from "../assets/djohwoww-ss-1400.webp";
import nextplayWeb1Small from "../assets/case/nextplay-web-1-700.webp";
import nextplayWeb1Large from "../assets/case/nextplay-web-1-1400.webp";
import nextplayWeb2Small from "../assets/case/nextplay-web-2-700.webp";
import nextplayWeb2Large from "../assets/case/nextplay-web-2-1400.webp";
import nextplayWeb3Small from "../assets/case/nextplay-web-3-700.webp";
import nextplayWeb3Large from "../assets/case/nextplay-web-3-1400.webp";
import nextplayApp1Small from "../assets/case/nextplay-app-1-600.webp";
import nextplayApp1Large from "../assets/case/nextplay-app-1-1200.webp";
import nextplayApp2Small from "../assets/case/nextplay-app-2-600.webp";
import nextplayApp2Large from "../assets/case/nextplay-app-2-1200.webp";
import nextplayApp3Small from "../assets/case/nextplay-app-3-600.webp";
import nextplayApp3Large from "../assets/case/nextplay-app-3-1200.webp";
import nextplayApp4Small from "../assets/case/nextplay-app-4-600.webp";
import nextplayApp4Large from "../assets/case/nextplay-app-4-1200.webp";
import nextplayApp5Small from "../assets/case/nextplay-app-5-600.webp";
import nextplayApp5Large from "../assets/case/nextplay-app-5-1200.webp";
import ambeWeb1Small from "../assets/case/ambe-web-1-700.webp";
import ambeWeb1Large from "../assets/case/ambe-web-1-1400.webp";
import ambeWeb2Small from "../assets/case/ambe-web-2-700.webp";
import ambeWeb2Large from "../assets/case/ambe-web-2-1400.webp";
import ambeWeb3Small from "../assets/case/ambe-web-3-700.webp";
import ambeWeb3Large from "../assets/case/ambe-web-3-1400.webp";
import ambeWeb4Small from "../assets/case/ambe-web-4-700.webp";
import ambeWeb4Large from "../assets/case/ambe-web-4-1400.webp";
import ambeApp1Small from "../assets/case/ambe-app-1-600.webp";
import ambeApp1Large from "../assets/case/ambe-app-1-1200.webp";
import ambeApp2Small from "../assets/case/ambe-app-2-600.webp";
import ambeApp2Large from "../assets/case/ambe-app-2-1200.webp";
import ambeApp3Small from "../assets/case/ambe-app-3-600.webp";
import ambeApp3Large from "../assets/case/ambe-app-3-1200.webp";
import ambeApp4Small from "../assets/case/ambe-app-4-600.webp";
import ambeApp4Large from "../assets/case/ambe-app-4-1200.webp";
import curzonreloApp1Small from "../assets/case/curzonrelo-app-1-600.webp";
import curzonreloApp1Large from "../assets/case/curzonrelo-app-1-1200.webp";
import curzonreloApp2Small from "../assets/case/curzonrelo-app-2-600.webp";
import curzonreloApp2Large from "../assets/case/curzonrelo-app-2-1200.webp";
import curzonreloApp3Small from "../assets/case/curzonrelo-app-3-600.webp";
import curzonreloApp3Large from "../assets/case/curzonrelo-app-3-1200.webp";
import curzonreloApp4Small from "../assets/case/curzonrelo-app-4-600.webp";
import curzonreloApp4Large from "../assets/case/curzonrelo-app-4-1200.webp";
import curzonreloApp5Small from "../assets/case/curzonrelo-app-5-600.webp";
import curzonreloApp5Large from "../assets/case/curzonrelo-app-5-1200.webp";
import curzonreloApp6Small from "../assets/case/curzonrelo-app-6-600.webp";
import curzonreloApp6Large from "../assets/case/curzonrelo-app-6-1200.webp";
import persystApp1Small from "../assets/case/persyst-app-1-600.webp";
import persystApp1Large from "../assets/case/persyst-app-1-1200.webp";
import persystApp2Small from "../assets/case/persyst-app-2-600.webp";
import persystApp2Large from "../assets/case/persyst-app-2-1200.webp";
import persystApp3Small from "../assets/case/persyst-app-3-600.webp";
import persystApp3Large from "../assets/case/persyst-app-3-1200.webp";
import persystApp4Small from "../assets/case/persyst-app-4-600.webp";
import persystApp4Large from "../assets/case/persyst-app-4-1200.webp";
import chinesepodWeb1Small from "../assets/case/chinesepod-web-1-700.webp";
import chinesepodWeb1Large from "../assets/case/chinesepod-web-1-1400.webp";
import chinesepodWeb2Small from "../assets/case/chinesepod-web-2-700.webp";
import chinesepodWeb2Large from "../assets/case/chinesepod-web-2-1400.webp";
import chinesepodWeb3Small from "../assets/case/chinesepod-web-3-700.webp";
import chinesepodWeb3Large from "../assets/case/chinesepod-web-3-1400.webp";
import chinesepodWeb4Small from "../assets/case/chinesepod-web-4-700.webp";
import chinesepodWeb4Large from "../assets/case/chinesepod-web-4-1400.webp";
import chinesepodApp1Small from "../assets/case/chinesepod-app-1-600.webp";
import chinesepodApp1Large from "../assets/case/chinesepod-app-1-1200.webp";
import chinesepodApp2Small from "../assets/case/chinesepod-app-2-600.webp";
import chinesepodApp2Large from "../assets/case/chinesepod-app-2-1200.webp";
import chinesepodApp3Small from "../assets/case/chinesepod-app-3-600.webp";
import chinesepodApp3Large from "../assets/case/chinesepod-app-3-1200.webp";
import chinesepodApp4Small from "../assets/case/chinesepod-app-4-600.webp";
import chinesepodApp4Large from "../assets/case/chinesepod-app-4-1200.webp";
import chinesepodApp5Small from "../assets/case/chinesepod-app-5-600.webp";
import chinesepodApp5Large from "../assets/case/chinesepod-app-5-1200.webp";
import chinesepodApp6Small from "../assets/case/chinesepod-app-6-600.webp";
import chinesepodApp6Large from "../assets/case/chinesepod-app-6-1200.webp";
import { SITE } from "./site";

const images = {
  nextplay: {
    small: nextplay700,
    large: nextplay1400,
    width: 1400,
    height: 875,
    alt: "The NextPlay Nutrition marketing site",
  },
  ambe: {
    small: ambe700,
    large: ambe1400,
    width: 1400,
    height: 875,
    alt: "The Ambé Wellness website",
  },
  curzonrelo: {
    small: curzonrelo700,
    large: curzonrelo1400,
    width: 1400,
    height: 875,
    alt: "CurzonRelo app screens: choosing a destination, building a property brief, and the advisor view",
  },
  persyst: {
    small: persyst700,
    large: persyst1400,
    width: 1400,
    height: 788,
    alt: "The PerSyst Fitness Trainer exercise screen with lift weight, body weight and target sliders",
  },
  chinesepodSite: {
    small: chinesepodSite700,
    large: chinesepodSite1400,
    width: 1400,
    height: 875,
    alt: "The ChinesePod website",
  },
  chinesepod: {
    small: chinesepod700,
    large: chinesepod1400,
    width: 1400,
    height: 875,
    alt: "ChinesePod app screens: vocabulary levels, the lesson library and lesson notes",
  },
  djohwoww: {
    small: djohwoww700,
    large: djohwoww1400,
    width: 1400,
    height: 875,
    alt: "The DJ OhWoww website",
  },
};

/** Client quotes are verbatim; do not edit their tone, grammar or punctuation. */
export const TESTIMONIALS = [
  {
    quote:
      "Bryant has been an absolute angel for my company, can't recommend him enough. He's very caring, trustworthy and competent. Anyone would be lucky to work with him.",
    projectId: "ambe",
    attribution: "Upwork client · Ambé Wellness",
  },
  {
    quote:
      "Bryant did an excellent work! I've hired many freelancers and he is one of the best. Had a can-do attitude and was a pleasure to work with. He went above and beyond fixing an issue that came up. I highly recommend him!!",
    projectId: "persyst",
    attribution: "Upwork client · PerSyst Fitness Trainer",
  },
  {
    quote:
      "Bryant did an incredible job on my DJ website. He was extremely communicative and responded quickly. I highly recommend his work.",
    projectId: "djohwoww",
    attribution: "Upwork client · DJ OhWoww",
  },
];

const slide = (small, large, width, height, label, alt) => ({
  img: { small, large, width, height },
  label,
  alt,
});

// External arrows belong in an aria-hidden span, separate from the link label.
export const CASE_STUDIES = [
  {
    slug: "nextplay",
    tags: ["Website", "Mobile app", "Backend"],
    cardText: "Nutrition coaching platform where every corporate client gets its own secure setup.",
    name: "NextPlay Nutrition",
    outcome: "Every corporate client gets its own dedicated AWS setup, served by one shared web app.",
    paragraphs: [],
    kicker: "2025–present · Web, mobile and backend",
    summary:
      "Nutrition coaching for members. A dedicated platform for every business.",
    buildNote: {
      heading: "The part you don't see",
      text: "Add an enterprise client in the admin console and a dedicated AWS stack is created for them: their own sign-in, API, data storage and subdomain. One shared web app serves every client.",
    },
    roleLine: "Our role: Architecture, backend, web and mobile.",
    stack: "Next.js · Flutter · AWS",
    context:
      "Coaching with registered dietitians and chefs, informed by bloodwork, wearables and questionnaires.",
    img: images.nextplay,
    media: {
      website: [
        slide(
          nextplayWeb1Small, nextplayWeb1Large, 1400, 875,
          "Home",
          "NextPlay Nutrition home page: \"Nutrition tailored to your health\" with Get Started and Request Demo buttons"
        ),
        slide(
          nextplayWeb2Small, nextplayWeb2Large, 1400, 875,
          "Individuals",
          "The Individuals page: \"NextPlay for You\""
        ),
        slide(
          nextplayWeb3Small, nextplayWeb3Large, 1400, 875,
          "Businesses",
          "The Businesses page: \"NextPlay for Your Business\" with platform highlights"
        ),
      ],
      app: [
        slide(
          nextplayApp1Small, nextplayApp1Large, 555, 1200,
          "Home",
          "App home screen with the day's calories, macros and today's meals"
        ),
        slide(
          nextplayApp2Small, nextplayApp2Large, 555, 1200,
          "Daily plan",
          "Daily plan with a week calendar, macro targets and meals by time of day"
        ),
        slide(
          nextplayApp3Small, nextplayApp3Large, 555, 1200,
          "Meal Finder",
          "Meal Finder listing nearby restaurant meals with match scores and macros"
        ),
        slide(
          nextplayApp4Small, nextplayApp4Large, 555, 1200,
          "Meal Builder",
          "Meal Builder with a week of planned breakfasts, lunches and dinners"
        ),
        slide(
          nextplayApp5Small, nextplayApp5Large, 555, 1200,
          "Health",
          "Health screen linking nutrition targets, bloodwork, body scan, recommendations and wearables"
        ),
      ],
    },
    links: [
      { label: "Visit NextPlay Nutrition", href: "https://nextplaynutrition.com" },
    ],
  },
  {
    slug: "ambe",
    tags: ["Website", "Mobile app", "Backend"],
    cardText: "HIPAA-compliant telehealth membership, live on the App Store since May 2026.",
    name: "Ambé Wellness",
    outcome: "A HIPAA-compliant membership platform, live in the App Store since May 2026.",
    testimonialId: "ambe",
    kicker: "2026",
    roleLine: "Our role: Backend, mobile app and website",
    paragraphs: [
      "A tele-wellness membership connecting people with doctors trained in Ayurvedic medicine. Consultations, medicine delivery and ongoing messaging, brought together across a Flutter app, Firebase backend and Next.js site.",
      "The platform handles protected health information, so HIPAA compliance shaped the architecture from the start. The app reached the App Store in May 2026.",
    ],
    img: images.ambe,
    media: {
      website: [
        slide(
          ambeWeb1Small, ambeWeb1Large, 1400, 875,
          "Home",
          "Ambé Wellness home page: \"Holistic-Doctor led care. Pay as you can.\""
        ),
        slide(
          ambeWeb2Small, ambeWeb2Large, 1400, 875,
          "Shop",
          "The shop page: \"Remedies made for you\" with product filters"
        ),
        slide(
          ambeWeb3Small, ambeWeb3Large, 1400, 875,
          "Membership",
          "The membership page: \"Your Wellness. Fully Covered.\" with plan benefits"
        ),
        slide(
          ambeWeb4Small, ambeWeb4Large, 1400, 875,
          "Health Tech",
          "The health technology page: \"The science of feeling well has advanced.\""
        ),
      ],
      app: [
        slide(
          ambeApp1Small, ambeApp1Large, 553, 1200,
          "Welcome",
          "Welcome screen: \"Holistic-Doctor led care. Pay as you like.\" with a Get Started button"
        ),
        slide(
          ambeApp2Small, ambeApp2Large, 553, 1200,
          "Store",
          "In-app store of Ayurvedic remedies with Add buttons"
        ),
        slide(
          ambeApp3Small, ambeApp3Large, 538, 1200,
          "Sign in",
          "Sign-in screen with email and password fields"
        ),
        slide(
          ambeApp4Small, ambeApp4Large, 538, 1200,
          "Onboarding",
          "Onboarding screen: \"Tired of one size fits all supplements?\""
        ),
      ],
    },
    links: [
      { label: "Visit website", href: "https://www.ambewellness.com/" },
      {
        label: "App Store",
        href: "https://apps.apple.com/us/app/ambe-wellness/id6523417737",
      },
    ],
  },
  {
    slug: "curzonrelo",
    tags: ["Mobile app", "Admin dashboard"],
    cardText: "Relocation app we built, then rebuilt completely. Now on version 3.4.",
    name: "CurzonRelo",
    outcome: "Built, then rebuilt completely. Now on version 3.4.",
    kicker: "2022–2025",
    roleLine: "Our role: iOS, Android and admin dashboard",
    paragraphs: [
      "Moving country starts with a lot of questions. This app lets members plan their move and connect with a personal relocation advisor. The advisors have a dashboard to work from, too.",
      "We built the original app, then rebuilt it completely. Both the app and the dashboard are written in Flutter, so one codebase covers iOS and Android. It's now on version 3.4, and has been in the App Store since November 2022.",
    ],
    img: images.curzonrelo,
    media: {
      website: [],
      app: [
        slide(
          curzonreloApp1Small, curzonreloApp1Large, 675, 1200,
          "Sign in",
          "App Store frame: \"Your Personal Global Relocation Service\" with the sign-in screen"
        ),
        slide(
          curzonreloApp2Small, curzonreloApp2Large, 675, 1200,
          "Relocating",
          "App Store frame: \"For Anyone, Relocating Anywhere, On Any Budget\" with a route map"
        ),
        slide(
          curzonreloApp3Small, curzonreloApp3Large, 675, 1200,
          "Overview",
          "App Store frame: the relocation brief overview"
        ),
        slide(
          curzonreloApp4Small, curzonreloApp4Large, 675, 1200,
          "Destination",
          "App Store frame: \"Select Your Destination\" on a map"
        ),
        slide(
          curzonreloApp5Small, curzonreloApp5Large, 675, 1200,
          "Property brief",
          "App Store frame: choosing property type, bedrooms and bathrooms"
        ),
        slide(
          curzonreloApp6Small, curzonreloApp6Large, 675, 1200,
          "ReloAdvisor",
          "App Store frame: the ReloAdvisor view with scheduled calls"
        ),
      ],
    },
    links: [
      {
        label: "View on the App Store",
        href: "https://apps.apple.com/us/app/curzonrelo/id1636041231",
      },
    ],
  },
  {
    slug: "persyst",
    tags: ["Tablet app", "Bluetooth"],
    cardText: "Tablet app that controls a strength-training machine over Bluetooth.",
    name: "PerSyst Fitness Trainer",
    outcome: "A tablet app that drives a strength-training machine over Bluetooth.",
    testimonialId: "persyst",
    kicker: "2023",
    roleLine: "Our role: Mobile app development",
    paragraphs: [
      "Software that talks to a training machine. This Flutter tablet app connects over Bluetooth LE to Arduino-driven hardware, sends exercise and assist-mode selections, and displays live lift metrics.",
      "The hard part: there's a loaded bar on the other end of the connection. The app has to stay responsive to a machine it doesn't control, and handle a lost connection in the middle of a set. In the App Store since January 2023.",
    ],
    img: images.persyst,
    media: {
      website: [],
      app: [
        slide(
          persystApp1Small, persystApp1Large, 2134, 1200,
          "Exercise",
          "Exercise screen with lift weight, body weight and target one-rep-max sliders"
        ),
        slide(
          persystApp2Small, persystApp2Large, 2134, 1200,
          "Mode",
          "Mode screen: pyramids, assists, burns, negatives and blocks"
        ),
        slide(
          persystApp3Small, persystApp3Large, 2134, 1200,
          "Assisted lift",
          "A bench press with assist in progress"
        ),
        slide(
          persystApp4Small, persystApp4Large, 2134, 1200,
          "Results",
          "Hoist Assist results with strength and muscle-growth gauges"
        ),
      ],
    },
    links: [
      {
        label: "View on the App Store",
        href: "https://apps.apple.com/us/app/persyst-fitness-trainer/id1612292587",
      },
    ],
  },
  {
    slug: "chinesepod",
    tags: ["Backend", "Mobile apps"],
    cardText: "Version 2 of the API behind an established Mandarin-learning app.",
    name: "ChinesePod",
    outcome: "Version 2 of the API behind an established learning app.",
    kicker: "January–June 2024",
    roleLine: "Our role: Backend rewrite and mobile technical lead",
    img: images.chinesepodSite,
    media: {
      website: [
        slide(
          chinesepodWeb1Small, chinesepodWeb1Large, 1400, 875,
          "Home",
          "ChinesePod home page: \"Learn Mandarin with ChinesePod\""
        ),
        slide(
          chinesepodWeb2Small, chinesepodWeb2Large, 1400, 875,
          "Why ChinesePod",
          "The \"Why ChinesePod\" section and course levels from Newbie to Advanced"
        ),
        slide(
          chinesepodWeb3Small, chinesepodWeb3Large, 1400, 875,
          "For companies",
          "The corporate page: \"Business Chinese (Mandarin) Training for Corporate Clients\""
        ),
        slide(
          chinesepodWeb4Small, chinesepodWeb4Large, 1400, 875,
          "For schools",
          "The schools page: \"Mandarin Chinese Programs for Schools & Educators\""
        ),
      ],
      app: [
        slide(
          chinesepodApp1Small, chinesepodApp1Large, 675, 1200,
          "Lessons",
          "App Store screenshot of the home screen with lesson categories"
        ),
        slide(
          chinesepodApp2Small, chinesepodApp2Large, 675, 1200,
          "Playlists",
          "App Store screenshot of HSK vocabulary playlists"
        ),
        slide(
          chinesepodApp3Small, chinesepodApp3Large, 675, 1200,
          "Dialogue",
          "App Store screenshot of a lesson's dialogue transcript"
        ),
        slide(
          chinesepodApp4Small, chinesepodApp4Large, 675, 1200,
          "Vocabulary",
          "App Store screenshot of lesson vocabulary in Chinese, pinyin and English"
        ),
        slide(
          chinesepodApp5Small, chinesepodApp5Large, 675, 1200,
          "Flashcards",
          "App Store screenshot of flashcard practice"
        ),
        slide(
          chinesepodApp6Small, chinesepodApp6Large, 675, 1200,
          "Settings",
          "App Store screenshot of account settings and download options"
        ),
      ],
    },
    paragraphs: [
      "An established Mandarin-learning platform needed a new API for an existing audience and content library. We built version 2 in Node.js and led technical decisions for the native iOS and Android apps, working with the client's distributed teams in Pakistan and the Philippines.",
    ],
    context:
      "The app has been in the App Store since 2017. Our work was on the API and mobile apps; chinesepod.com was built by others.",
    links: [
      { label: "Explore the client's product", href: "https://www.chinesepod.com/" },
      {
        label: "App Store",
        href: "https://apps.apple.com/us/app/chinesepod/id1185380819",
      },
    ],
  },
];

export const CASE_PAGE_COPY = {
  back: { label: "← All work", href: "/#work" },
  builtWith: "Built with",
  nextProject: "Next project",
  media: {
    website: "Website",
    app: "App",
    previous: "Previous screenshot",
    next: "Next screenshot",
  },
  heading: "Want something like this built?",
  cta: { label: "Tell us about your project", href: "/#contact" },
};

export const WEBSITES = [
  {
    id: "djohwoww",
    name: "DJ OhWoww",
    description: "A promotional site for a live DJ and instrumentalist act.",
    short: "Promo site for a live DJ act",
    links: [{ label: "Visit DJ OhWoww", href: "https://www.djohwoww.com/" }],
  },
  {
    id: "madeinvestment",
    name: "Made Investment Group",
    description: "A marketing website for an investment firm.",
    short: "Marketing site for an investment firm",
    links: [
      {
        label: "Visit Made Investment Group",
        href: "https://madeinvestmentgroup.com/",
      },
    ],
  },
];

export const SERVICES = [
  {
    name: "Websites",
    summary: "A site that shows what you do and makes it easy to reach you.",
    points: [
      "Marketing and promo sites",
      "Membership and sign-up sites",
      "Web apps connected to your product",
    ],
  },
  {
    name: "Mobile apps",
    summary: "iPhone and Android apps, built and taken through App Store review.",
    points: [
      "The backend and APIs behind the app",
      "Admin dashboards for your team",
      "Taking over or rebuilding an existing app",
    ],
  },
  {
    name: "IT support",
    summary: "Help keeping your business tech up and running.",
    points: [
      "Day-to-day technical help",
      "Straight advice before you spend on new software",
    ],
  },
  {
    name: "Data and AI",
    summary: "Put the data your business already has to use.",
    points: [
      "Reports and dashboards from your data",
      "AI features, where they actually fit",
    ],
  },
];

export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "work", label: "Work" },
  { id: "process", label: "How we work" },
  { id: "about", label: "About" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export const DESKTOP_NAV_LINKS = NAV_LINKS.filter(({ id }) =>
  ["services", "work", "about", "contact"].includes(id)
);
export const FOOTER_NAV_LINKS = NAV_LINKS.filter(({ id }) => id !== "process");

export const PROCESS_STEPS = [
  {
    heading: "Tell us what you need",
    text: "Call or send the form. You'll talk directly with the person building it, not a salesperson.",
  },
  {
    heading: "Work out the plan together",
    text: "We figure out what to build, what it will take and what fits your budget.",
  },
  {
    heading: "Built in-house",
    text: "Every design and every line of code is done by us. Nothing is outsourced.",
  },
  {
    heading: "Launch and hand-over",
    text: "We put it live, or through App Store review, and you own all of it: the code and the design.",
  },
];

export const FAQ_ITEMS = [
  {
    question: "What does a project cost?",
    answer: ["It depends on the scope. Tell us your budget up front and we'll work out what makes sense."],
  },
  {
    question: "How long does it take?",
    answer: ["It ranges with the project. A marketing site and a full app platform are very different builds, so we'll talk timing once we know what you need."],
  },
  {
    question: "Who owns the code and design?",
    answer: ["You do. Everything we build for you is yours at the end."],
  },
  {
    question: "Do you work with clients outside New Jersey?",
    answer: ["Yes. We're based in Northern New Jersey and work with clients wherever they are."],
  },
  {
    question: "Can you take over an existing app or website?",
    answer: [
      "Yes. ",
      { label: "ChinesePod", href: "/work/chinesepod/" },
      " and ",
      { label: "PerSyst", href: "/work/persyst/" },
      " were already live products when we started on them, and ",
      { label: "CurzonRelo", href: "/work/curzonrelo/" },
      "'s app was rebuilt from the ground up.",
    ],
  },
  {
    question: "What do you need from me to get started?",
    answer: ["Just a rough idea of what your business does and what you want built. Rough ideas are fine. We'll work out the details together."],
  },
];

export const PAGE_COPY = {
  homeTitle: "AlmanzaTech — Custom Websites, Apps & IT Support · Northern New Jersey",
  startProject: { label: "Start a project", href: "/#contact" },
  header: {
    skipLink: { label: "Skip to the work", href: "/#work" },
    menu: "Menu",
  },
  hero: {
    heading: "Custom websites, apps and IT support for small businesses and founders.",
    proof: "Built in-house. Live in the App Store.",
    cta: { label: "Tell us about your project", href: "/#contact" },
  },
  work: {
    heading: "Selected work",
    intro: "A few recent client projects. Open any of them for the full story.",
    caseLink: "View project",
    websitesCard: {
      tags: ["Websites"],
      name: "Two recent websites",
      img: images.djohwoww,
    },
  },
  services: {
    heading: "What we do",
    intro: "Not sure which you need? Tell us what you're trying to do and we'll figure it out together.",
    cta: { label: "Tell us about your project", href: "/#contact" },
  },
  process: {
    heading: "How working with us works",
    intro: "No big agency process. You talk to the person building it, from the first call to launch.",
  },
  about: {
    heading: "About us",
    lead: "AlmanzaTech builds websites, apps and the systems behind them in Northern New Jersey.",
    body: "When you get in touch, you talk directly with the person who builds it. We treat you like family here, and that starts with listening to what you want to build and what you can spend.",
    reviewsHeading: "What clients say",
  },
  faq: {
    heading: "Questions people ask",
  },
  contact: {
    heading: "Tell us about your project.",
    intro:
      "A few lines about your business and what you need is plenty. Budgets can be tight; we understand and will work with you.",
    phoneHeading: "A phone call works, too.",
    hoursHeading: "Hours",
    hours: ["Monday–Friday · 9 AM–6 PM", "Saturday · 10 AM–1 PM"],
    company: SITE.name,
    location: SITE.location,
    fields: {
      name: "Your name",
      email: "Email address",
      message: "What would you like to build?",
    },
    need: {
      legend: "What do you need? (optional)",
      options: [
        { value: "website", label: "Website" },
        { value: "app", label: "App" },
        { value: "it-support", label: "IT support" },
        { value: "not-sure", label: "Not sure" },
      ],
    },
    hint: "Rough ideas are fine.",
    submit: "Send message",
    sending: "Sending",
    success: {
      heading: "Message sent",
      message:
        "We'll get back to you soon. If it's urgent, call (201) 467-1007.",
      reset: "Send another",
    },
    error:
      "That didn't go through. Please try again, or email bryant@almanzatech.com.",
    recaptcha: {
      text: "This site is protected by reCAPTCHA.",
      privacyBefore: " Read our ",
      privacyLink: "privacy policy",
      privacyAfter: ".",
    },
  },
  footer: {
    tagline: "Websites, apps and the systems behind them.",
    copyright: `© ${new Date().getFullYear()} ${SITE.name}`,
    privacy: { label: "Privacy policy", href: "/privacy/" },
  },
  callbar: { label: "Call us", href: SITE.phoneHref },
};
